import { Record } from '@common/data-models/records/record';
import { SingleViewStateRecord } from '@common/data-models/records/single-viewstate-record';
import { ViewStateTypes } from "@common/enums/viewstate-types";

import { ViewStateOptions } from "@common/data-models/navigation/viewstate-options";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";


export class SingleFeedViewStateRecord extends SingleViewStateRecord {
    
    public initialize() {
        this.viewStateType = ViewStateTypes.SINGLEFEED;
        super.initialize();
    }
    
    public get viewStateFeedID(): string { return this.getAs<string>(PSTFieldNames.PSTViewStateFeedID); }
    public set viewStateFeedID(value: string) { this.set(PSTFieldNames.PSTViewStateFeedID, value); }
}
